import { render, staticRenderFns } from "./SysApiMockValueModal.vue?vue&type=template&id=ddbd9d30&"
import script from "./SysApiMockValueModal.vue?vue&type=script&lang=js&"
export * from "./SysApiMockValueModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports